import React, { Component } from 'react'
import {connect } from 'react-redux';
import {logOut,userLogin} from "../../Redux/ducks/authReducer";
import {Alert,Spinner} from 'reactstrap';
import { Redirect } from "react-router-dom";
import ReactJsAlert from "reactjs-alert"
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

export class Login extends Component {
    constructor(props) {
        super(props);
        this.props.logOut("loginPage");
        this.state = {
            username:'',
            password:'',
            errorMsg:'',
            isValidating:false,
            goDashboard:false,
            alertStatus :false, alertType :"error", alertTitle:null,
            email1:"",phone:"",email:"",type:null,veficationStatus:1,code:""
        };
      }

    componentDidUpdate(prevProps){
        const{userLoginStatus,userLoginMsg} = this.props;
        if(userLoginStatus !==prevProps.userLoginStatus){
        
            if(userLoginStatus===false){
                const userData = JSON.parse(window.localStorage.getItem('userData'));
                const veficationStatus = userData.veficationStatus
              
                    this.setState({isValidating:false,goDashboard:true,veficationStatus:1});
                    /*go to dashboard*/
                
               

            }else if(userLoginStatus===true){
                this.setState({isValidating:false,goDashboard:false,
                alertStatus :true, alertType :"error", alertTitle:userLoginMsg})
            }
        }
    }

    onChange = e =>{
        this.setState({[e.target.name] : e.target.value});
    };

    createBTN= e =>{
        const {email1,phone} = this.state
        e.preventDefault();
        this.setState({isValidating:false})
        if(email1 ==="" || phone ===""){
            this.setState({  alertStatus :true, alertType :"error", alertTitle:"Enter Email and phone number"})
        }else{
            this.setState({errorMsg : "",isValidating:true,type:2});
            this.props.userLogin(email1,phone,"START");
        }
    };
    loginBTN= e =>{
        const {email} = this.state
        e.preventDefault();
        this.setState({isValidating:false})
        if(email ===""){
            this.setState({  alertStatus :true, alertType :"error", alertTitle:"Enter Email or phone"})
        }else{
            this.setState({errorMsg : "",isValidating:true,type:1});
            this.props.userLogin(email,null,"RESUME");
        }
    };

    verifyBTN= e =>{
        const {email1,code,email} = this.state
        e.preventDefault();
        this.setState({isValidating:false})
        if(code ===""){
            this.setState({  alertStatus :true, alertType :"error", alertTitle:"Enter Verification code from that has been sent to your email"})
        }else{
            this.setState({errorMsg : "",isValidating:true,type:3});
            let emailSend = email1===""?email:email1
            this.props.userLogin(emailSend,code,"VERIFY");
        }
    };
    showAlert =e =>{
        alert('To resend code, enter your email and click RESUME APPLICATION');
        // Reload the page
        window.location.reload();
    }

    
    render(){
        if(this.state.goDashboard){
            return <Redirect push to="/dashboard" />  
        }
        return(
            <>
            <ReactJsAlert autoCloseIn ={600000} status={this.state.alertStatus} type={this.state.alertType} title={this.state.alertTitle} Close={() => this.setState({ alertStatus: false })}/>
            <div className="loginWrapper">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-10 col-lg-12 col-md-9">
                            <div className="card o-hidden border-0 shadow-lg my-5">
                                <div className="card-body p-0">
                                    <div className="row">
                                        <div className="col-lg-6 d-none d-lg-block bg-login-image">
                                            <img src={process.env.PUBLIC_URL+'/assets/img/home3.png'} alt="login"/>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="p-5">
                                                <div className="text-center">
                                                    <h1 className="h4 text-gray-900 mb-4 hhead">ST JOHN'S S.S NANDERE APPLICATION LINK</h1>
                                                </div>
                                             
                                     
                                                <form className="user">
                                                    <h6>LOGIN TO RESUME APPLICATION </h6>
                                                 
                                                    <div className="form-group">
                                                        <input type="text" name="email" onChange={this.onChange} className="form-control form-control-user form-control2" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Enter Email Or phone (256...)"/>
                                                    </div>
                                                
                                                    {parseInt(this.state.type) ===1?
                                                    <>
                                                    {this.state.isValidating?<div><Spinner className="mySpinner" color="primary" /><Spinner className="mySpinner" color="primary" type="grow"/>{'Validating...'}</div>:null}

                                                    </>
                                                    :null}                                                   
                                                     <a href="#" onClick={this.loginBTN} className="btn btn-success btn-user btn-block btn33">
                                                    LOGIN
                                                    </a>
                                                </form> 
                                                <hr/>
                                                    <h5 className='midN'>OR</h5>
                                                <hr/>
                                                <form className="user">
                                                    <h6>CREATE ACCOUNT TO APPLY</h6>
                                                    <div className="form-group">
                                                        <PhoneInput
                                                        country={'ug'}
                                                        value={this.state.phone}
                                                        onChange={phone => this.setState({ phone })}
                                                        inputStyle={{width:"100%",height:50}}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input type="email" name="email1" onChange={this.onChange} className="form-control form-control-user form-control2" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Enter Email Address..."/>
                                                    </div>
                                                   
                                                    {parseInt(this.state.type) ===2?
                                                    <>
                                                    {this.state.isValidating?<div><Spinner className="mySpinner" color="primary" /><Spinner className="mySpinner" color="primary" type="grow"/>{'Validating...'}</div>:null}

                                                    </>
                                                    :null}
                                                    <a href="#" onClick={this.createBTN} className="btn btn-primary btn-user btn-block btn33">
                                                    CREATE ACCOUNT TO APPLY
                                                    </a>
                                                </form>
                                                <br/>
                                                <span className='loginLog'>For any help call +256772529297, +256704596102</span><br/>
                                                <a className='loginLog' href="https://mutanik.com/" target="_blank" >Developed By Mutanik Technologies</a>

                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
            </>
         
        )
    }
}
const mapStateToProps = (state) =>({
    userLoginStatus:state.authReducer.userLoginStatus,
    userLoginMsg:state.authReducer.userLoginMsg
});
export default connect(
    mapStateToProps,{logOut,userLogin}
)(Login)
